import { useState } from 'react';
import { UseBaseThreeDotMenuProps, UseBaseThreeDotMenuReturn } from './types';

export const useBaseThreeDotMenu = ({
  onMenuOpen,
  onMenuClose,
}: UseBaseThreeDotMenuProps): UseBaseThreeDotMenuReturn => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>): void => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    onMenuOpen?.();
  };

  const handleMenuClose = (): void => {
    setAnchorEl(null);
    onMenuClose?.();
  };

  const handleMenuItemClick = (onClick: () => void): void => {
    onClick();
    handleMenuClose();
  };

  return {
    anchorEl,
    isOpen: Boolean(anchorEl),
    handleMenuOpen,
    handleMenuClose,
    handleMenuItemClick,
  };
};
